import React from "react";
import { Circle, Group, Line } from "react-konva";

import { Stem } from "@examspark/types";

interface Props {
  x: number;
  y: number;
  type: Stem.Mark;
}

/**
 * Renders a crosshairs-like image meant to allow a candiate to mark a certain
 * spot over top an `ImageMap`.
 * @param props
 */
const Mark: React.FC<React.PropsWithChildren<Props>> = (props) => {
  let color = "#000";
  if (props.type) {
    switch (props.type) {
      case "incorrect":
        color = "#ba2a2a";
        break;
      case "correct":
        color = "#2fb92f";
        break;
    }
  }

  return (
    <Group x={props.x} y={props.y}>
      <Circle
        radius={15}
        fill="rgba(255, 255, 255, 0.5)"
        stroke={color}
        strokeWidth={2}
      />
      <Line points={[-8, -8, 8, 8]} stroke={color} strokeWidth={2} />
      <Line points={[-8, 8, 8, -8]} stroke={color} strokeWidth={2} />
    </Group>
  );
};

export default Mark;
